import { render, staticRenderFns } from "./StatsTab.vue?vue&type=template&id=6e6073c9&lang=pug&"
import script from "./StatsTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StatsTab.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports